import { render, staticRenderFns } from "./newDirectPkg.vue?vue&type=template&id=cf3098cc&scoped=true&"
import script from "./newDirectPkg.vue?vue&type=script&lang=js&"
export * from "./newDirectPkg.vue?vue&type=script&lang=js&"
import style0 from "./newDirectPkg.vue?vue&type=style&index=0&id=cf3098cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3098cc",
  null
  
)

export default component.exports